import Enum from "../../../enums/Enum";

const EnumCoPayUnit = new Enum({
    PERCENTAGE: "%",
    KWD: "KWD",
    AED: "AED"
});

export default EnumCoPayUnit;
